import Swiper from 'swiper';
import {Navigation, Pagination, Thumbs} from 'swiper/modules';

document.addEventListener('DOMContentLoaded', () => {

    const homeSlider = new Swiper('.js-news-detail-slider', {
        modules: [Navigation, Pagination],
        navigation: {
            nextEl: ".news-detail-slider-button-next",
            prevEl: ".news-detail-slider-button-prev",
        },
        pagination: {
            el: ".swiper-pagination",
        },
    });


    var swiper = new Swiper(".js-offices-address-slider", {
        spaceBetween: 10,
        slidesPerView: 4,
        freeMode: true,
        watchSlidesProgress: true,
    });

    var swiper2 = new Swiper(".js-offices-detail-slider", {
        modules: [Navigation, Thumbs],
        spaceBetween: 10,
        // navigation: {
        //     nextEl: ".swiper-button-next",
        //     prevEl: ".swiper-button-prev",
        // },
        thumbs: {
            swiper: swiper,
        },
    });

});